'use strict';

var formDynamicPagesTestDrive = function () {
  var formSelector = '.js-form-dynamic-pages';
  var $form = $(formSelector);
  var idConcesion = $('#pvCodhostTestDrive').val();
  var _getModels = function _getModels() {
    $.getJSON('https://red.nissan.es/getJsonModelosTD?pais=ES&conces=' + idConcesion).done(function (data) {
      return _buildModelsSelect(data);
    });
  };

  /* Build models for each concession */
  var _buildModelsSelect = function _buildModelsSelect(json) {
    var sortedModels = json.sort(function (a, b) {
      return a.orden - b.orden;
    });
    var listModels = '';
    listModels = '<option value="">Selecciona un modelo</option>';
    for (var i = 0; i < sortedModels.length; i++) {
      listModels += '<option value="' + sortedModels[i].nom_es + '" data-motor="' + sortedModels[i].engine_es + '">' + sortedModels[i].nom_es + '</option>';
    }
    $form.find('.js-field-model').html(listModels);
  };

  $('#generic-form__box--motor').hide();
  /* Add value motor engine model */
  $('#vModelo').on('change', function () {
    $('#typeMotor').html($('option:selected', this).data("motor"));
    $('#pvEngine').val($('option:selected', this).data("motor"));
    $('#generic-form__box--motor').fadeIn();
  });

  /* Start Add tick selects ok */
  $('.checking-select').on('change focusout', function () {
    $(this).parents('.generic-form__box').find('.selectedValue').html($(":selected", this).text());
    var thisSelect = $(this);
    var thisLabel = $(this).closest('.generic-form__box').find('label');
    setTimeout(function () {
      if (thisSelect.hasClass('valid')) {
        $(thisLabel).addClass('valid');
      } else {
        $(thisLabel).removeClass('valid');
      }
    }, 50);
  });

  $('.checking-input').on('keyup focusout', function () {
    var thisInput = $(this);
    var thisLabel = $(this).prev();
    setTimeout(function () {
      if (thisInput.hasClass('valid')) {
        $(thisLabel).addClass('valid');
      } else {
        $(thisLabel).removeClass('valid');
      }
    }, 50);
  });
  /* End Add tick selects ok */

  var _initValidation = function _initValidation() {
    var formValidate = new PlanValidator(formSelector, {
      fieldModel: true,
      fieldDealer: true,
      errorPlacement: function errorPlacement(error, element) {
        if (element.hasClass('js-field-model')) {
          if ($('.js-error-select-model').find('.error').length === 0) {
            $('.js-field-model').addClass('error');
            $('.js-error-select-model').append(error);
          }
        } else if (element.hasClass('js-field-dealer')) {
          if ($('.js-error-select-dealer').find('.error').length === 0) {
            $('.js-field-dealer').addClass('error');
            $('.js-error-select-dealer').append(error);
          }
        } else {
          element.after(error);
        }
      },
      submitHandler: function submitHandler(form) {
        var obj = {
          form: form,
          submit$Selector: '.js-label-submit',
          submitText: 'ENVIANDO...',
          toHide: '.js-to-hide',
          toShow: '.js-to-show',
          close$Selector: '.js-close',
          useReCaptcha: true,
          okURL: globalEnv + 'es/public/dist/_thankyou-ok-lead.html',
          koURL: globalEnv + 'es/public/dist/_thankyou-ko-lead.html'
        };
        window.googleDataLayer = window.googleDataLayer || [];
        window.googleDataLayer.push({
          'event': 'prueba vehiculo'
        });
        formCommons.sendAjax(obj);
      }
    });
  };

  var _init = function _init() {
    _getModels();
    _initValidation();
  };
  return {
    init: _init
  };
}();